// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal-title[data-v-25546c52] {\n  font-weight: 600;\n  font-size: 32px;\n  line-height: 120%;\n  letter-spacing: 0.01em;\n}\n.modal-p[data-v-25546c52] {\n  font-weight: 500;\n  line-height: 120%;\n  letter-spacing: 0.01em;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
